import { memberApiV2 } from '@lib/api';
import { TGetAlertHistoryResult, TGetAlertsParams } from 'types/alerts';
import { TPostSendEmail, TPostSendNotification, TPostSendSms } from 'types/member-api';

export function sendAnnouncementEmail(providerId: string, data: TPostSendEmail) {
  return memberApiV2.request('/management/private/announcement', {
    method: 'POST',
    params: { type: 'email' },
    data,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function sendAnnouncementPush(providerId: string, data: TPostSendNotification) {
  return memberApiV2.request('/management/private/announcement', {
    method: 'POST',
    params: { type: 'push' },
    data,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function sendAnnouncementSms(providerId: string, data: TPostSendSms) {
  return memberApiV2.request('/management/private/announcement', {
    method: 'POST',
    params: { type: 'sms' },
    data,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function getAnnouncements(params: TGetAlertsParams) {
  return memberApiV2.request<{ data: TGetAlertHistoryResult }>('/management/private/announcement', {
    method: 'GET',
    params,
  });
}
